/* VEÍZU – Produktkarten Mini-Slider
   Macht aus dem (bereits vorhandenen) 1. + 2. Produktbild einen
   wischbaren Slider mit dezenten Punkten. Greift nur, wenn ein
   2. Bild existiert. Desktop: Hover bleibt zusätzlich aktiv. */
(function () {
  function initCard(media) {
    var imgs = media.querySelectorAll(':scope > img');
    if (imgs.length < 2) return;
    if (media.dataset.vzInit) return;
    media.dataset.vzInit = '1';
    media.classList.add('vz-cardslider');

    var index = 0;
    var max = imgs.length - 1;

    // Punkte
    var dots = document.createElement('div');
    dots.className = 'vz-dots';
    for (var d = 0; d <= max; d++) {
      var b = document.createElement('span');
      b.className = 'vz-dot' + (d === 0 ? ' is-active' : '');
      dots.appendChild(b);
    }
    media.appendChild(dots);
    var dotEls = dots.querySelectorAll('.vz-dot');

    function show(n) {
      index = (n + imgs.length) % imgs.length;
      media.style.setProperty('--vz-active', index);
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.opacity = (i === index) ? '1' : '0';
        if (dotEls[i]) dotEls[i].classList.toggle('is-active', i === index);
      }
    }

    // Wischen (Touch + Maus-Drag)
    var startX = null;
    media.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    media.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX; startX = null;
      if (dx < -30) show(index + 1);
      else if (dx > 30) show(index - 1);
    });

    // Punkt-Klick
    dotEls.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i); });
    });
  }

  function run(scope) {
    (scope || document).querySelectorAll('.card__media .media--hover-effect').forEach(initCard);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });

  // Bei Theme-Editor-Updates erneut
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
